module.exports = __webpack_public_path__ + "static/media/005.0b468f6d.jpg";